import getMessage from 'src/background/utils/i18n.utils';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { SVGIcons } from 'src/common-ui/icons.enum';
import { Separator } from 'src/common-ui/separator/separator.component';
import { SVGIcon } from 'src/common-ui/svg-icon/svg-icon.component';
const FavoriteAccountsItem = ({ favorite, handleDeleteFavorite, handleEditFavoriteLabel, listName, }) => {
    const [label, setLabel] = useState('');
    const [isEditMode, setEditMode] = useState(false);
    const [isExpanded, setIsExpanded] = useState(false);
    const save = () => {
        setEditMode(false);
        handleEditFavoriteLabel(listName, favorite, label);
    };
    const cancel = () => {
        setEditMode(false);
        setLabel('');
    };
    const edit = (event, favorite) => {
        event.stopPropagation();
        setEditMode(true);
        setIsExpanded(false);
        setLabel(favorite.subLabel);
    };
    const deleteFavorite = (event, listname, favorite) => {
        event.stopPropagation();
        handleDeleteFavorite(listname, favorite);
    };
    const toggleExpandablePanel = () => {
        if (!isEditMode)
            setIsExpanded(!isExpanded);
    };
    return (React.createElement("div", { className: "favorite-accounts-item", onClick: toggleExpandablePanel },
        React.createElement("div", { className: "item" },
            React.createElement("div", { className: "item-details" },
                React.createElement("img", { className: "profile-picture", src: `https://steemitimages.com/u/${favorite.value}/avatar`, onError: (e) => {
                        e.target.onError = null;
                        e.target.src = '/assets/images/accounts.png';
                    } }),
                React.createElement("div", { className: "names" },
                    React.createElement("div", { className: "username" }, favorite.value),
                    React.createElement("div", { className: "label" }, favorite.subLabel ? `${favorite.subLabel}` : '')),
                isExpanded && !isEditMode && (React.createElement(SVGIcon, { icon: SVGIcons.GLOBAL_ARROW }))),
            isEditMode && (React.createElement("div", { className: "edit-panel" },
                React.createElement("input", { className: "edit-label", value: label, onChange: (e) => setLabel(e.target.value), placeholder: getMessage('popup_html_favorite_user_nickname') }),
                React.createElement(SVGIcon, { onClick: () => save(), icon: SVGIcons.FAVORITE_ACCOUNTS_SAVE, className: "edit-button" }),
                React.createElement(SVGIcon, { onClick: () => cancel(), icon: SVGIcons.FAVORITE_ACCOUNTS_CANCEL, className: "edit-button" })))),
        isExpanded && (React.createElement("div", { className: "expandable-panel" },
            React.createElement(Separator, { type: "horizontal" }),
            React.createElement("div", { className: "expandable-panel-content" },
                React.createElement("div", { className: "favorite-item-button edit", onClick: ($event) => edit($event, favorite) },
                    React.createElement(SVGIcon, { icon: SVGIcons.FAVORITE_ACCOUNTS_EDIT }),
                    React.createElement("span", { className: "label" }, getMessage('html_popup_button_edit_label'))),
                React.createElement("div", { className: "favorite-item-button delete", onClick: ($event) => deleteFavorite($event, listName, favorite) },
                    React.createElement(SVGIcon, { icon: SVGIcons.FAVORITE_ACCOUNTS_DELETE }),
                    React.createElement("span", { className: "label" }, getMessage('delete_label'))))))));
};
const mapStateToProps = (state) => {
    return {};
};
const connector = connect(mapStateToProps, {});
export const FavoriteAccountsItemComponent = connector(FavoriteAccountsItem);
